import React from "react";
import {
  ManaFontManaSymbols,
  ReplacedSymbolsOracleText,
} from "modules/common/components/ManaFontSymbols";
import { costPrintedToManaFontClasses } from "utils/utils";
import { CardFace } from "modules/cards/model/card";

interface Props {
  face: CardFace;
}

// Renders the inline header for a DFC/MDFC back face. Mirrors the MTG
// branch of CardEssentialInfo but accepts the slim CardFace shape — the
// Pokemon/Riftbound branches don't apply since otherFaces is MTG-only.
export const CardFaceInfo = ({ face }: Props) => {
  const faceName = face.name.split("//").at(-1)?.trim() || face.name;

  return (
    <div className="flex flex-col gap-2">
      <div className="mt-2 flex flex-row items-center justify-between gap-1 md:mt-0">
        <h1 className="text-primary text-xl">{faceName}</h1>
        <ManaFontManaSymbols
          className="ml-px"
          costPrinted={face.costPrinted ?? ""}
          extractClassesFunc={costPrintedToManaFontClasses}
        />
      </div>
      <p className="text-secondary text-lg">{face.type}</p>
      {face.text && (
        <ReplacedSymbolsOracleText
          oracleText={face.text}
          className="text-base-content ml-px"
        />
      )}
      {face.flavorText && (
        <ReplacedSymbolsOracleText
          oracleText={face.flavorText}
          className="text-secondary text-sm italic"
        />
      )}
    </div>
  );
};
